import { ActionsKanban } from "@/components/actions-kanban";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/actions",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { companyId } = Route.useParams();
  return <ActionsKanban companyId={companyId} />;
}
